import React, { useState, useEffect } from "react";
import axios from "axios";
import UserList from "../../components/Lists/UserList";
import GroupList from "../../components/Lists/GroupList";
import GroupForm from "../../components/Form/GroupForm";
import "../../assets/stylesheets/UserManagement.css";
import { fetchData, updateData, deleteData } from "../../api/api";
import EditGroupModal from "../../components/Modals/EditGroupModal";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

function UserManagement() {
  const [users, setUsers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [editDialogShow, setEditDialogShow] = useState(false);
  const [currentGroup, setCurrentGroup] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    fetchUsers();
    fetchGroups();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await fetchData("/accounts/get_users");
      setUsers(response);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const fetchGroups = async () => {
    try {
      const response = await fetchData("accounts/get_groups");
      setGroups(response);
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  const deleteGroup = async (groupId) => {
    try {
      const response = await deleteData(`/accounts/destroy_group/`, groupId);
      if (response) {
        fetchGroups();
      }
    } catch (error) {
      console.error("Error deleting group:", error);
    }
  };

  const handleEditGroup = (selectedGroup) => {
    setCurrentGroup(selectedGroup);
    setEditDialogShow(true);
  };

  const saveGroupChanges = async (groupId, newName, selectedUsers) => {
    try {
      const response = await updateData(
        `/accounts/update_group`,
        groupId,
        { name: newName, user_ids: selectedUsers },
        false
      );
      fetchGroups(); // Re-fetch groups after update
    } catch (error) {
      console.error("Error updating group:", error);
    }
  };

  const toggleAdmin = async (userId) => {
    const userIndex = users.findIndex((user) => user.id === userId);
    if (userIndex > -1) {
      const updatedUsers = users.map((user) =>
        user.id === userId
          ? { ...user, role_id: user.role_id === "admin" ? "user" : "admin" }
          : user
      );
      try {
        await updateData(`/accounts/toggle_admin`, userId, {});
        setUsers(updatedUsers);
      } catch (error) {
        console.error("Error toggling admin status:", error);
      }
    }
  };

  const toggleUserActivation = async (userId) => {
    try {
      await updateData(`accounts/toggle_user_activation`, userId, {});
      fetchUsers();
    } catch (error) {
      console.error("Error toggling user activation:", error);
    }
  };

  const deactivateUser = async (userId) => {
    try {
      await updateData(`accounts/de_activate_user`, userId, {});
      fetchUsers();
    } catch (error) {
      console.error("Error deactivating user:", error);
    }
  };

  return (
    <div className="user-management">
      <h1>Benutzermanagement</h1>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={(_, val) => setActiveTab(val)}
          sx={{
            "& .MuiTab-root.Mui-selected": { color: "#a63dc9" },
            "& .MuiTabs-indicator": { backgroundColor: "#a63dc9" },
          }}
        >
          <Tab label="Gruppen" />
          <Tab label="Benutzer" />
        </Tabs>
      </Box>

      {activeTab === 0 && (
        <>
          <GroupForm users={users} fetchGroups={fetchGroups} />
          <GroupList
            groups={groups}
            fetchGroups={fetchGroups}
            deleteGroup={deleteGroup}
            editGroup={handleEditGroup}
          />
        </>
      )}

      {activeTab === 1 && (
        <UserList
          users={users}
          toggleAdmin={toggleAdmin}
          toggleUserActivation={toggleUserActivation}
          deactivateUser={deactivateUser}
        />
      )}

      {currentGroup && (
        <EditGroupModal
          show={editDialogShow}
          handleClose={() => setEditDialogShow(false)}
          group={currentGroup}
          onSave={saveGroupChanges}
          allUsers={users}
        />
      )}
    </div>
  );
}

export default UserManagement;
